import { createContext } from "react";

const DF_OT0015Context = createContext();

export { DF_OT0015Context };
